import { render, staticRenderFns } from "./RootHeader.vue?vue&type=template&id=6b9da624&scoped=true&"
import script from "./RootHeader.vue?vue&type=script&lang=js&"
export * from "./RootHeader.vue?vue&type=script&lang=js&"
import style0 from "./RootHeader.vue?vue&type=style&index=0&id=6b9da624&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9da624",
  null
  
)

export default component.exports